import { NavLink } from 'react-router-dom';

const items = [
  { to: '/declarer',  label: 'Déclarer',  icon: '✏️' },
  { to: '/ventes',    label: 'Mes ventes', icon: '📊' },
  { to: '/classement', label: 'Classement', icon: '🏆' }
];

export function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 bg-white border-t border-border z-40"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="grid grid-cols-3 max-w-3xl mx-auto">
        {items.map(it => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              className={({ isActive }) =>
                `flex flex-col items-center py-2.5 text-xs transition-colors
                 ${isActive ? 'text-qts font-demi' : 'text-ink-sub'}`
              }
            >
              <span className="text-xl mb-0.5">{it.icon}</span>
              <span>{it.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
